import { useNavigate } from "react-router-dom";
import { getExhibitionContents, deleteExhibitionContent } from "./request";
import React, { useEffect, useState, useCallback } from "react";
import { useAuth } from "../context/AuthContext";
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

const ExhibitionContent = () => {
    const navigate = useNavigate();
    const { authToken } = useAuth();
    const [contents, setContents] = useState([]);
    const [loading, setLoading] = useState(false); // Track loading state

    const fetchContents = useCallback(async () => {
        setLoading(true);
        try {
            const response = await getExhibitionContents(authToken);
            if (response.Result) {
                const data = response.Contents;
                setContents(data);
            } else {
                console.error(response.Msg);
            }
        } catch (error) {
            console.error("Error fetching contents:", error);
        } finally {
            setLoading(false);
        }
    }, [authToken]);

    useEffect(() => {
        fetchContents();
    }, [authToken, fetchContents]);

    const handleDelete = async (id) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this content?");
        if (confirmDelete) {
            try {
                const response = await deleteExhibitionContent(authToken, id);
                if (response.Result) {
                    alert("Content deleted successfully!");
                    setContents((prevContents) =>
                        prevContents.filter((content) => content.id !== id)
                    ); // Optimistically update the UI
                } else {
                    alert("Failed to delete the content.");
                }
            } catch (error) {
                console.error("Error deleting content:", error);
                alert("An error occurred while deleting the content.");
            }
        }
    };

    const handleEditClick = (contentId) => {
        navigate('/exhibitioncontent/editExhibitionContent', { state: { contentId } });
    };

    return (
        <>
            <div className="container mx-auto p-4">
                {/* Header with Heading and Button */}
                <div className="flex justify-between items-center mb-4">
                    <h1 style={{ fontWeight: 700, fontSize: '2rem', color: '#222' }}>Exhibition Content</h1>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => navigate('/exhibitioncontent/addExhibitionContent')}
                    >
                        Add Content
                    </Button>
                </div>

                {/* Contents Table */}
                <div className="shadow-md rounded-lg overflow-x-auto bg-white">
                    {loading ? (
                        <div className="text-center py-4">Loading...</div>
                    ) : (
                        <table className="min-w-full table-auto ">
                            <thead className="bg-gray-100">
                                <tr>
                                    <th className="py-3 px-4 text-left font-semibold">ID</th>
                                    <th className="py-3 px-4 text-left font-semibold">Title</th>
                                    <th className="py-3 px-4 text-left font-semibold">Year</th>
                                    <th className="py-3 px-4 text-left font-semibold">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {contents.map((content) => (
                                    <tr key={content.id} className="border-b hover:bg-gray-50">
                                        <td className="py-3 px-4">{content.id}</td>
                                        <td className="py-3 px-4">{content.title}</td>
                                        <td className="py-3 px-4">{content.year}</td>
                                        <td className="py-3 px-4">
                                            <Stack direction="row" spacing={1}>
                                                <Button variant="contained" color="primary" onClick={() => handleEditClick(content.id)}>Edit</Button>
                                                <Button variant="contained" color="error" onClick={() => handleDelete(content.id)}>Delete</Button>
                                            </Stack>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </>
    );
};

export default ExhibitionContent;